import * as yup from 'yup';
export var ValidationString;
(function (ValidationString) {
    ValidationString["GLOBAL"] = "Une erreur est survenue, veuillez r\u00E9essayer.";
    ValidationString["ADMIN_LOGIN"] = "Une erreur est survenue, vous essayez peut-\u00EAtre de vous connecter avec un compte administrateur ?";
    ValidationString["INVALID_USERNAME"] = "Identifiant inconnu. V\u00E9rifiez l\u2019orthographe ou essayez avec votre adresse e-mail.";
    ValidationString["INVALID_EMAIL"] = "Adresse e-mail inconnue. V\u00E9rifiez l\u2019orthographe ou essayez avec votre identifiant.";
    ValidationString["INVALID_PASSWORD"] = "Le mot de passe que vous avez saisi est incorrect.";
    ValidationString["PROFILE"] = "Une erreur est survenue lors de la mise \u00E0 jour de votre profil.";
    ValidationString["REQUIRED"] = "Ce champ est obligatoire.";
    ValidationString["EMAIL"] = "Veuillez entrer une adresse email valide.";
    ValidationString["ZIPCODE"] = "Veuillez entrer un code postal valide.";
    ValidationString["PHONE"] = "Veuillez entrer un num\u00E9ro de t\u00E9l\u00E9phone valide.";
    ValidationString["NUMBER"] = "Veuillez entrer un nombre";
    ValidationString["ARRAY_MIN_LENGTH"] = "Veuillez s\u00E9lectionner au moins un \u00E9l\u00E9ment.";
    ValidationString["FILE_SIZE"] = "Le fichier est trop volumineux.";
    ValidationString["FILE_REQUIRED"] = "Veuillez s\u00E9lectionner un fichier.";
    ValidationString["PASSWORD"] = "Veuillez indiquer un mot de passe comprenant au moins 8 caract\u00E8res, dont 1 majuscule, 1 minuscule, 1 chiffre et 1 caract\u00E8re sp\u00E9cial.";
    ValidationString["PASSWORD_CONFIRM"] = "Les mots de passe ne correspondent pas.";
    ValidationString["GDPR"] = "Veuillez accepter les conditions d'utilisation.";
    ValidationString["CONSENT_IDENTITY"] = "Veuillez accepter les conditions";
    ValidationString["URL"] = "Veuillez entrer une URL valide.";
    ValidationString["AVATAR"] = "Veuillez ajouter votre photo ou s\u00E9lectionner un avatar pour continuer.";
    ValidationString["MAX_LENGTH"] = "Veuillez entrer au maximum {max} \u00E9l\u00E9ments.";
    ValidationString["LOCATION"] = "Veuillez saisir une localisation ou enlever le rayon de recherche.";
    ValidationString["LOCATION_TYPE"] = "Veuillez saisir une localisation valide.";
    ValidationString["EXPIRED_SESSION"] = "Votre session a expir\u00E9, veuillez vous reconnecter";
})(ValidationString || (ValidationString = {}));
var passwordInstructions = 'Votre mot de passe doit contenir au moins 8 caractères, dont 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial choisi uniquement parmi les suivants : @$!%*#?&.()€§:=-';
var phoneRegex = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
var phoneOptionalRegex = /^$|^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/;
var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&.()€§:=-])[A-Za-z\d@$!%*#?&.()€§:=-]{8,}$/;
export var useValidation = function () {
    return {
        textOptional: yup.string().notRequired(),
        textRequired: yup.string().required(ValidationString.REQUIRED),
        passwordRequired: yup
            .string()
            .required(ValidationString.REQUIRED)
            .matches(passwordRegex, ValidationString.PASSWORD),
        passwordConfirmation: function (key) {
            return yup
                .string()
                .oneOf([yup.ref(key), null], ValidationString.PASSWORD_CONFIRM)
                .required(ValidationString.REQUIRED);
        },
        numberRequired: yup
            .number()
            .typeError(ValidationString.NUMBER)
            .required(ValidationString.REQUIRED),
        zipCodeRequired: yup
            .string()
            .required(ValidationString.REQUIRED)
            .matches(/^[0-9]+$/, ValidationString.ZIPCODE)
            .min(5, ValidationString.ZIPCODE)
            .max(5, ValidationString.ZIPCODE),
        emailRequired: yup.string().email(ValidationString.EMAIL).required(ValidationString.REQUIRED),
        phoneOptional: yup.string().notRequired().matches(phoneOptionalRegex, ValidationString.PHONE),
        gdprRequired: yup
            .boolean()
            .oneOf([true], ValidationString.GDPR)
            .required(ValidationString.GDPR),
        consentIdentity: yup
            .boolean()
            .oneOf([true], ValidationString.CONSENT_IDENTITY)
            .required(ValidationString.CONSENT_IDENTITY),
        arrayRequired: yup
            .array()
            .min(1, ValidationString.ARRAY_MIN_LENGTH)
            .typeError(ValidationString.REQUIRED)
            .required(ValidationString.REQUIRED),
        arrayNullable: yup.array().nullable(),
        objectRequired: yup.object().required(),
        fileRequired: yup
            .array()
            .min(1, ValidationString.FILE_REQUIRED)
            .typeError(ValidationString.FILE_REQUIRED)
            .required(ValidationString.FILE_REQUIRED),
        booleanNullable: yup.boolean(),
        booleanRequired: yup
            .boolean()
            .oneOf([true], ValidationString.REQUIRED)
            .required(ValidationString.REQUIRED),
        avatarRequired: yup.string().required(ValidationString.AVATAR),
        locationRequired: yup.mixed().required(ValidationString.REQUIRED),
        locationOptional: yup.mixed().typeError(ValidationString.LOCATION_TYPE).nullable(),
        urlRequired: yup.string().url(ValidationString.URL).required(),
        urlOptional: yup.string().url(ValidationString.URL).notRequired(),
        links: function (max) {
            return yup
                .array()
                .of(yup.object().shape({
                title: yup.string().required(ValidationString.REQUIRED),
                url: yup.string().url(ValidationString.URL).required(ValidationString.REQUIRED),
            }))
                .max(max, ValidationString.MAX_LENGTH)
                .nullable();
        },
        softwares: function (max) {
            return yup
                .array()
                .of(yup.object().shape({
                software: yup.string().required(ValidationString.REQUIRED),
            }))
                .max(max, ValidationString.MAX_LENGTH)
                .nullable();
        },
        languages: function (max) {
            return yup
                .array()
                .of(yup.object().shape({
                language: yup.string().required(ValidationString.REQUIRED),
            }))
                .max(max, ValidationString.MAX_LENGTH)
                .nullable();
        },
        collaborations: function (max) {
            return yup
                .array()
                .of(yup.object().shape({
                collaboration: yup.string().required(ValidationString.REQUIRED),
            }))
                .max(max, ValidationString.MAX_LENGTH)
                .nullable();
        },
        locationWithRadius: function (radiusKey) {
            return yup
                .object()
                .nullable()
                .when(radiusKey, {
                is: function (value) { return value && value > 0; },
                then: yup
                    .object()
                    .typeError(ValidationString.LOCATION)
                    .required(ValidationString.LOCATION),
            });
        },
        passwordInstructions: passwordInstructions,
    };
};
